@let l = line();
<nz-space class="gpio-status-space" nz-col nzAlign="center">
  <nz-tag i18n-nzTooltipTitle nzTooltipTitle="machine is on" nzTooltipPlacement="bottom" nz-tooltip [nzColor]="l.machineIsOn ? 'darkgreen' : 'darkred'">
    <span nz-icon nzType="poweroff"></span>
  </nz-tag>

  <nz-tag i18n-nzTooltipTitle nzTooltipTitle="line is on" nzTooltipPlacement="bottom" nz-tooltip [nzColor]="l.lineIsOn ? 'darkgreen' : 'darkred'">
    <span nz-icon nzType="icons:assembly-line"></span>
  </nz-tag>

  <nz-tag i18n-nzTooltipTitle nzTooltipTitle="raise alarm" nzTooltipPlacement="bottom" nz-tooltip [nzColor]="l.raiseAlarm ? 'darkred' : 'default'">
    <span nz-icon nzType="alert"></span>
  </nz-tag>

  <nz-tag
    i18n-nzTooltipTitle
    nzTooltipTitle="bucket is in the scanner"
    nzTooltipPlacement="bottom"
    nz-tooltip
    [nzColor]="l.bucketIsInTheScanner ? 'darkgreen' : 'default'"
  >
    <span nz-icon nzType="icons:scanner"></span>
  </nz-tag>

  <nz-tag
    class="continue-tag"
    i18n-nzTooltipTitle
    nzTooltipTitle="continue"
    nzTooltipPlacement="bottom"
    nz-tooltip
    [nzColor]="l.continue ? 'darkgreen' : 'default'"
    (click)="toggleContinue()"
  >
    <span nz-icon nzType="caret-right" style="margin-inline-start: 1px"></span>
  </nz-tag>

  <nz-tag i18n-nzTooltipTitle nzTooltipTitle="eject" nzTooltipPlacement="bottom" nz-tooltip [nzColor]="l.eject ? 'darkgreen' : 'default'">
    <span nz-icon nzType="export"></span>
  </nz-tag>

  @if (l.replaying) {
    <nz-tag nzColor="orange" i18n="@@lineReplayBadge">REPLAY</nz-tag>
  }
</nz-space>
